import { useEffect, useState } from "react";
import StaticDropdown from "../../Components/Dropdown/StaticDropdown";
import Form from "../../Components/Form";
import { ISettingDTO, OrderbookSource } from "../../Interfaces/setting";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import Button from "../../Components/Button";
import { getExeConfig, setExeConfig } from "../../Requests/setting";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { CheckBox, TextInput } from "src/Components";

const Setting = () => {
  const [formValues, setFormValues] = useState({} as ISettingDTO);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getExeConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const orderbookSourceOptions: DropdownItem[] = [
    { id: OrderbookSource.TSE, name: "TSE-Dideban" },
    { id: OrderbookSource.Sahra, name: "Sahra" },
    { id: OrderbookSource.SahraPush, name: "sahraPush" },
    { id: OrderbookSource.OrderBook, name: "TSEPage" },
    { id: OrderbookSource.OrderBookOld, name: "Old Version" },
    { id: OrderbookSource.Ramand, name: "Ramand" },
    { id: OrderbookSource.RamandSite, name: "ramandSite" },
    { id: OrderbookSource.VirtualOrderbook, name: "VirtualOrderbook" },
  ];
  const imeOrderbookSourceOptions: DropdownItem[] = [
    { id: OrderbookSource.TadbirIME, name: "TadbirIME" },
    { id: OrderbookSource.CdnIME, name: "CdnIME" },
    { id: OrderbookSource.SahraIME, name: "SahraIME" },
  ];

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    setExeConfig(formValues)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 !mx-auto gap-3 p-3">
      {loading ? <FullScreenLoading /> : <></>}
      <StaticDropdown
        dropdown={{
          name: "orderbookSource",
          placeholder: "سورس دیتای اوردربوک",
          extraLabel: true,
        }}
        options={orderbookSourceOptions}
        onChange={changeHandler}
        value={formValues.orderbookSource}
      />
      <StaticDropdown
        dropdown={{
          name: "imEorderbookSource",
          placeholder: "سورس دیتای IME",
          extraLabel: true,
        }}
        options={imeOrderbookSourceOptions}
        onChange={changeHandler}
        value={formValues.imEorderbookSource}
      />
      <TextInput
        label="تعداد روز قبل نمایش داده شده در پلتفرم"
        value={formValues.orderConfigDayCount?.toString()}
        name="orderConfigDayCount"
        onChange={changeHandler}
        kind="number"
        extraLabel
      />
      <CheckBox
        checked={formValues.orderConfigHistoryAutoReset}
        name="orderConfigHistoryAutoReset"
        onChange={changeHandler}
        label="ریست شدن اتوماتیک نمایش روز قبل در اول روز معاملاتی"
      />
      <Button text="ثبت" variant="contained" onClick={submitHandler} />
    </Form>
  );
};

export default Setting;
